<!--
	提现
	lovi 2019-12-30
-->
<template>
  <div>
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("wallet.withdraw") }}</BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" @click="returnFun" v-if="detailFlag">
        {{ $t("common.back") }}
      </a>
    </div>
    <div class="recharge-type" v-if="!detailFlag">
      <a
        href="javascript:void(0);"
        :class="{ active: withdrawType == 0 }"
        @click="changeType(0)"
      >
        {{ $t("withdraw.bankCardWithdraw") }}
      </a>
      <a
        href="javascript:void(0);"
        :class="{ active: withdrawType == 1 }"
        @click="changeType(1)"
      >
        {{ $t("withdraw.aliPayWithdraw") }}
      </a>
    </div>
    <div class="list-wrap" v-show="!detailFlag">
      <Form
        v-show="withdrawType == 0"
        ref="bankRef"
        :model="bankModel"
        :rules="bankRule"
        :label-width="120"
        label-position="right"
      >
        <FormItem :label="$t('wallet.selectBankCard') + '：'" prop="bankCardId">
          <Select
            v-model="bankModel.bankCardId"
            :placeholder="$t('wallet.selectBankCard')"
            :disabled="bankList.length == 0"
            @on-change="changeBankCard"
          >
            <Option v-for="item in bankList" :value="item.id" :key="item.id">
              {{ item.bank_name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          :label="$t('withdraw.withdrawAmount') + '：'"
          prop="money"
          class="ivu-form-money"
        >
          <div class="input-money">
            <InputNumber
              v-model="bankModel.money"
              :min="0"
              :placeholder="$t('common.enterAmount')"
            />
            <span>P</span>
          </div>
          <div class="tips">
            <span class="text-orange">
              <template v-if="country == 1 || country == 3">
                ≈{{ country == 1 ? "￥" : "" }}
                {{ withdrawMoney }}
                {{ country == 3 ? "VND" : "" }}
              </template>
            </span>
            <div class="info">
              <span>{{ feeTips }}</span>
              <span>
                {{ $t("common.balance") }}：{{
                  userInfo.money_usable ? userInfo.money_usable : "--"
                }}P</span
              >
              <a href="javascript:void(0)" @click="allMoney">
                {{ $t("withdraw.withdrawAll") }}
              </a>
            </div>
          </div>
        </FormItem>
        <FormItem
          :label="$t('common.payPsd') + '：'"
          prop="password"
          class="item-password"
        >
          <Input
            v-model="bankModel.password"
            type="password"
            password
            :placeholder="$t('common.enterPayPsd')"
          />
        </FormItem>
      </Form>
      <!-- 支付宝提现 -->
      <Form
        v-show="withdrawType == 1"
        ref="aliPayRef"
        :model="aliPayModel"
        :rules="aliPayRule"
        :label-width="120"
        label-position="right"
      >
        <FormItem :label="$t('withdraw.aliPayAccount') + '：'" prop="alipay">
          <Input
            type="text"
            v-model="aliPayModel.alipay"
            :placeholder="$t('common.enterAliPay')"
          />
        </FormItem>
        <FormItem :label="$t('common.name') + '：'" prop="name">
          <Input
            type="text"
            v-model="aliPayModel.name"
            :placeholder="$t('common.enterName')"
          />
        </FormItem>
        <FormItem :label="$t('common.mobileNumber') + '：'" prop="phone">
          <Input
            type="text"
            v-model="aliPayModel.phone"
            :placeholder="$t('common.enterMobile')"
          />
        </FormItem>
        <FormItem
          :label="$t('withdraw.withdrawAmount') + '：'"
          prop="money"
          class="ivu-form-money"
        >
          <div class="input-money">
            <InputNumber
              v-model="aliPayModel.money"
              :min="0"
              :placeholder="$t('common.enterAmount')"
            />
            <span>P</span>
          </div>
          <div class="tips">
            <span class="text-orange">≈￥{{ withdrawMoney }}</span>
            <div class="info">
              <span>{{ feeTips }}</span>
              <span>
                {{ $t("common.balance") }}：{{
                  userInfo.money_usable ? userInfo.money_usable : "--"
                }}P
              </span>
              <a href="javascript:void(0)" @click="allMoney">
                {{ $t("withdraw.withdrawAll") }}
              </a>
            </div>
          </div>
        </FormItem>
      </Form>
      <div class="button-wrap">
        <Button type="primary" long @click="confirmFun" :loading="btnLoading">
          {{ $t("common.confirm") }}
        </Button>
      </div>
      <p class="withdrawTips text-gray">
        <template
          v-if="
            (withdrawType == 0 && bankModel.bankCardId) || withdrawType == 1
          "
        >
          {{ $t("withdraw.singleWithdrawalLimited") }}
          {{
            (curData.amount_min ? curData.amount_min : "--") +
              "P-" +
              (curData.amount_max ? curData.amount_max : "--") +
              "P"
          }}
          <br />
        </template>
        {{ $t("withdraw.monthWithdrawalLimited") }}
        {{ configData.tx_raming ? configData.tx_raming : "--" }}P
      </p>
    </div>

    <!-- 详情 -->
    <detail
      v-if="detailFlag"
      :detailFlag.sync="detailFlag"
      :order_id="detail.id"
      :type="2"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as validate from "@/commonJs/validate";
import Detail from "@/components/detail";
// 校验银行卡
export default {
  name: "wallet-withdraw",
  components: {
    Detail
  },
  data() {
    const checkBankCardId = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("wallet.selectBankCard")));
      } else {
        callback();
      }
    };
    const checkMoney = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.enterAmount")));
      } else {
        callback();
      }
    };
    const checkAlipay = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.enterAliPay")));
      } else {
        callback();
      }
    };
    const checkName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.enterName")));
      } else {
        callback();
      }
    };
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.enterMobile")));
      } else {
        callback();
      }
    };
    return {
      withdrawType: 0,
      bankModel: {
        bankCardId: "",
        money: 0,
        password: ""
      },
      bankRule: {
        bankCardId: [
          {
            trigger: "change",
            required: true,
            validator: checkBankCardId
          }
        ],
        money: [
          {
            trigger: "blur",
            required: true,
            validator: checkMoney
          }
        ],
        password: [
          {
            trigger: "blur",
            required: true,
            validator: validate.validatePayPsd
          }
        ]
      },

      aliPayModel: {
        alipay: "",
        name: "",
        phone: "",
        money: 0
      },
      aliPayRule: {
        alipay: [
          {
            trigger: "blur",
            required: true,
            validator: checkAlipay
          }
        ],
        name: [
          {
            trigger: "blur",
            required: true,
            validator: checkName
          }
        ],
        phone: [
          {
            trigger: "blur",
            required: true,
            validator: checkPhone
          }
        ],
        money: [
          {
            trigger: "blur",
            required: true,
            validator: checkMoney
          }
        ]
      },

      configData: {}, //配置数据
      curData: {},

      bankList: [],

      bankId: "",
      country: "", // 银行卡归属地
      btnLoading: false, // 按钮loading
      withdrawMoney: "--", // 提现折算金额
      feeTips: "", //手续费
      // 详情
      detailFlag: false, // 详情页Flag
      detail: {}
    };
  },
  created() {
    this.getWithdrawalToBank();
    this.$store.dispatch("GET_USER_INFO");
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    returnFun() {
      // 返回
      this.detailFlag = false;
      let name = this.withdrawType == 0 ? "bankRef" : "aliPayRef";
      this.$refs[name].resetFields();
      this.withdrawMoney = "--";
      this.feeTips = "";
      this.bankId = "";
      this.country = "";
      if (this.withdrawType == 1) {
        this.aliPayModel.alipay = "";
        this.aliPayModel.name = "";
        this.aliPayModel.phone = "";
        this.aliPayModel.money = 0;
      } else {
        this.bankModel.bankCardId = "";
        this.bankModel.money = 0;
        this.bankModel.password = "";
      }
      console.log("bankModel", this.bankModel);
    },
    changeType(type) {
      //切换提现类别
      this.returnFun();
      this.withdrawType = type;
    },
    serviceCharge(amount) {
      // 计算手续费
      let vm = this;
      // 账户余额
      if (!amount) {
        vm.withdrawMoney = "--";
        vm.feeTips = "";
        return;
      }
      let money = parseFloat(vm.userInfo.money_usable);
      // 手续费计算
      let feeTips = "";
      let fee, money1, money2;
      fee = vm.curData.percentage;
      // 具体金额
      money1 = vm.curData.check_money;
      money2 = vm.curData.check_service_money;
      if (vm.withdrawType == 0) {
        if (vm.country == "") {
          return;
        }
        if (vm.curData.type == 0) {
          feeTips =
            vm.$t("common.serviceRate") +
            Number(fee) * 100 +
            "%(" +
            vm.$t("common.minServiceCharge") +
            vm.curData.low_fee +
            "P)";
        } else {
          fee = Number(
            Math.ceil(amount / Number(money1)) * Number(money2)
          ).toFixed(2);
          feeTips = vm.$t("common.serviceCharge") + fee + "P";
          if (money <= Number(vm.curData.low_fee) || money <= fee) {
            vm.$toast(vm.$t("common.insufficientAccountBalance"));
            return;
          }
        }
      } else {
        if (vm.curData.type == 0) {
          feeTips =
            vm.$t("common.serviceRate") +
            Number(fee) * 100 +
            "%(" +
            vm.$t("common.minServiceCharge") +
            vm.curData.low_fee +
            "P)";
        } else {
          fee = Number(Math.ceil(amount / money1) * money2).toFixed(2);
          feeTips = vm.$t("common.serviceCharge") + fee + "P";
        }
      }
      vm.withdrawMoney = vm._PHPtoRMB(amount, vm.curData.rate);
      vm.feeTips = feeTips;
    },
    allMoney() {
      // 全部金额
      if (this.withdrawType == 0) {
        this.bankModel.money = parseFloat(this.userInfo.money_usable);
      } else {
        this.aliPayModel.money = parseFloat(this.userInfo.money_usable);
      }
    },
    changeBankCard(id) {
      let vm = this;
      for (let key of vm.bankList) {
        if (id == key.id) {
          vm.country = key.country;
          vm.bankId = key.id;
        }
      }
      vm.curData =
        vm.country == 1
          ? vm.configData.rmb
          : vm.country == 2
          ? vm.configData.php
          : vm.configData.vnd;
      console.log("curData", vm.curData);
      console.log(vm.country, "country");
    },
    confirmFun() {
      let vm = this;
      let name = vm.withdrawType == 0 ? "bankRef" : "aliPayRef";
      vm.$refs[name].validate().then(valid => {
        if (valid) {
          vm.cashWithdrawal();
        } else {
          vm.$Message.error(vm.$t("common.enterCorrectInformation"));
        }
      });
    },
    cashWithdrawal() {
      // 提现
      let vm = this;
      let params = {};
      if (vm.withdrawType == 0) {
        // 银行卡提现
        if (vm.bankModel.money < 0) {
          vm.$Message.warning(vm.$t("common.enterCorrectAmount"));
          return false;
        }
        if (vm.bankModel.money > parseFloat(vm.configData.tx_raming)) {
          // 提现金额大于本月提现金额
          vm.$Message.warning(
            vm.$t("withdraw.withdrawalAmountGreaterThanMonth")
          );
          return false;
        }
        if (vm.bankModel.money > parseFloat(vm.userInfo.money_usable)) {
          vm.$Message.warning(vm.$t("common.insufficientAccountBalance"));
          return false;
        }
        params.operate = 8;
        params.money = vm.bankModel.money;
        params.country = vm.country;
        params.bank_card_id = vm.bankId;
        params.pay_password = vm.bankModel.password;
      } else {
        // 支付宝提现
        if (vm.aliPayModel.money < 0) {
          vm.$Message.warning(vm.$t("common.enterCorrectAmount"));
          return false;
        }
        if (vm.aliPayModel.money > parseFloat(vm.configData.tx_raming)) {
          // 提现金额大于本月提现金额
          vm.$Message.warning(
            vm.$t("withdraw.withdrawalAmountGreaterThanMonth")
          );
          return false;
        }
        if (vm.aliPayModel.money > parseFloat(vm.userInfo.money_usable)) {
          vm.$Message.warning(vm.$t("common.insufficientAccountBalance"));
          return false;
        }
        params.operate = 11;
        params.alipay = vm.aliPayModel.alipay;
        params.name = vm.aliPayModel.name;
        params.phone = vm.aliPayModel.phone;
        params.money = vm.aliPayModel.money;
      }
      // 该币种不支持
      if (vm.curData.status == 0) {
        vm.$Message.info(vm.$t("withdraw.currencyNotSupportWithdrawals"));
        return;
      }
      vm.$post("/app/pay/cashWithdrawal", params, { loading: true }).then(
        res => {
          console.log("cashWithdrawal", res);
          vm.$store.dispatch("GET_USER_INFO");
          vm.getWithdrawalToBank();
          vm.detailFlag = true;
          if (vm.withdrawType == 0) {
            vm.detail = res.list[0];
          } else {
            vm.detail = res;
          }
        }
      );
    },
    getWithdrawalToBank() {
      // 获取提现到银行卡页面信息
      let vm = this;
      vm.$post("/app/pay/WithdrawalToBank", {}, { loading: true }).then(res => {
        console.log("WithdrawalToBank", res);
        vm.configData = res.withdraw_config;
        vm.bankList = res.list;
      });
    }
  },
  watch: {
    bankModel: {
      handler(newObj) {
        this.serviceCharge(newObj.money);
      },
      deep: true
    },
    aliPayModel: {
      handler(newObj) {
        this.curData = this.configData.zfb;
        this.serviceCharge(newObj.money);
      },
      deep: true
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.recharge-type {
  margin-top: 15px;
  height: 45px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #bfbfbf;
  a {
    height: 100%;
    font-size: 18px;
    color: #4a4a4a;
    display: flex;
    align-items: center;
    &.active {
      color: #2042ab;
      position: relative;
      &:after {
        content: "";
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background: #2042ab;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
  a + a {
    margin-left: 50px;
  }
}
.list-wrap {
  padding: 50px 160px;

  .ivu-form-money {
    .tips {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      color: #666;

      .info {
        span {
          margin-right: 10px;
        }

        a {
          color: #2042ab;
          text-decoration: underline;

          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }

  .item-password {
    /deep/.ivu-input {
      padding-right: 40px;
    }
    /deep/.ivu-input-suffix {
      cursor: pointer;
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      .ivu-icon {
        font-size: 22px;
        color: #2042ab;
      }
    }
  }

  /deep/.ivu-form {
    .ivu-form-item-label {
      line-height: 20px;
      font-size: 16px;
    }

    .ivu-form-item-content {
      .ivu-input,
      .ivu-select-selection {
        height: 40px;
      }

      .ivu-select-placeholder,
      .ivu-select-selected-value {
        padding-top: 5px;
        padding-bottom: 5px;
        height: 40px;
        font-size: 14px;
      }

      .ivu-select-item {
        line-height: 20px;
      }

      .ivu-input-icon {
        width: 40px;
        height: 40px;
        line-height: 40px;
      }

      .ivu-input-number {
        width: 100%;
        height: 40px;
      }
      .input-money {
        display: flex;
        align-items: center;
        justify-content: space-between;
        /deep/.ivu-input-number {
          width: calc(100% - 20px);
        }
      }

      .ivu-input-number-input-wrap {
        height: 40px;
      }

      .ivu-input-number-handler {
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .ivu-input-number-input {
        height: 38px;
        line-height: 38px;
      }
    }

    .ivu-form-item-validating .ivu-input-icon + .ivu-input {
      padding-right: 40px;
    }

    .ivu-form-item-btn {
      text-align: center;
    }

    .ivu-btn-primary {
      width: 250px;
      height: 45px;
      font-size: 20px;
    }
  }
}

.withdrawTips {
  text-align: center;
}
</style>
